<template>
  <el-card v-loading="loading">
    <el-descriptions v-if="taskDetail" title="任务详情" :column="2" border>
      <el-descriptions-item label="任务编号">{{ taskDetail.code }}</el-descriptions-item>
      <el-descriptions-item label="创建时间">{{ taskDetail.createdAt }}</el-descriptions-item>
      <el-descriptions-item label="已完成设备数">{{ taskDetail.finishedEquipmentCount }}</el-descriptions-item>
      <el-descriptions-item label="任务ID">{{ taskDetail.id }}</el-descriptions-item>
      <el-descriptions-item label="外部ID">{{ taskDetail.outerId }}</el-descriptions-item>
    </el-descriptions>

    <template v-if="taskDetail && taskDetail.regions">
      <div v-for="(region, regionIndex) in taskDetail.regions" :key="regionIndex" style="margin-top: 20px;">
        <h3>区域 {{ regionIndex + 1 }}</h3>
        <div v-for="(equipment, equipmentIndex) in region.equipments" :key="equipmentIndex" style="margin-left: 20px;">
          <h4>设备: {{ equipment.equipmentName }} ({{ equipment.equipmentCode }})</h4>
          <div v-for="(position, positionIndex) in equipment.positions" :key="positionIndex" style="margin-left: 20px;">
            <h5>位置: {{ position.position }}</h5>
            <p>提示信息: {{ position.promptMessage }}</p>
            <el-table :data="position.checkItems" border style="width: 100%">
              <el-table-column prop="content" label="检查项内容" />
              <el-table-column prop="type" label="类型" />
              <el-table-column label="测量结果">
                <template slot-scope="scope">
                  <div v-if="scope.row.batchMeasureResult && scope.row.batchMeasureResult.length > 0">
                    <p v-for="(measure, measureIndex) in scope.row.batchMeasureResult" :key="measureIndex">
                      {{ measure.name }}: {{ measure.value }}
                    </p>
                  </div>
                  <span v-else>{{ scope.row.measureResult }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="result" label="结果">
                <template slot-scope="scope">
                  <span>{{ scope.row.result }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="result" label="图片">
                <template slot-scope="scope">
                  <template v-if="scope.row.uploadPhotos.length > 0">
                    <el-image
                      v-for="(image,imageIndex) in scope.row.uploadPhotos"
                      :key="imageIndex"
                      class="image"
                      :preview-src-list="[scope.row.uploadPhotos]"
                      :src="image"
                      fit="contain"
                    />
                  </template>
                  <span v-else />
                </template>
              </el-table-column>
              <el-table-column prop="description" label="描述">
                <template slot-scope="scope">
                  <span>{{ scope.row.description }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </template>
  </el-card>
</template>

<script>
import { getTaskChecklistDetail } from '@/api/test/tpm'
export default {
  name: 'Detail',
  data() {
    return {
      id: null,
      taskDetail: null,
      loading: false
    }
  },
  created() {
    if (this.$route.params && this.$route.params.hasOwnProperty('id')) {
      this.id = this.$route.params.id
      this.getDetail()
    }
  },
  methods: {
    getDetail() {
      this.loading = true
      getTaskChecklistDetail(this.id).then(resp => {
        this.taskDetail = resp
        this.loading = false
      }).catch(() => { this.loading = false })
    }
  }
}
</script>

<style scoped>
h3, h4, h5 {
  margin-bottom: 10px;
}
</style>
